export const ITEMS = [
  { label: 'TypeScript', category: 'Web Development', r: 20,  g: 20,  b: 20  },
  { label: 'Bike',       category: 'Sports',          r: 150, g: 150, b: 150 },
  { label: 'Chess',      category: 'Hobbies',         r: 75,  g: 75,  b: 75  },
  { label: 'C#',         category: 'Web Development', r: 110, g: 110, b: 110 },
  { label: 'Squash',     category: 'Sports',          r: 42,  g: 42,  b: 42  },
  { label: 'Books',      category: 'Hobbies',         r: 130, g: 130, b: 130 },
  { label: 'Java',       category: 'Web Development', r: 62,  g: 62,  b: 62  },
  { label: 'Badminton',  category: 'Sports',          r: 95,  g: 95,  b: 95  },
  { label: 'AI',         category: 'Web Development', r: 168, g: 168, b: 168 },
  { label: 'Investments', category: 'Hobbies',        r: 52,  g: 52,  b: 52  },
]

export const EXTERNAL_ICON_URLS = {
  Badminton:   'https://img.icons8.com/?size=512&id=24310&format=png&color=000000',
  Squash:      'https://img.icons8.com/?size=512&id=CtRSGGt11eua&format=png&color=000000',
  Bike:        'https://img.icons8.com/?size=512&id=257&format=png&color=000000',
  Investments: 'https://img.icons8.com/?size=512&id=mZwAWZnhQ9oJ&format=png&color=000000',
  Java:        'https://img.icons8.com/?size=512&id=38294&format=png&color=000000',
  TypeScript:  'https://img.icons8.com/?size=512&id=QikVS4SSLfDg&format=png&color=000000',
  'C#':        'https://img.icons8.com/?size=512&id=55204&format=png&color=000000',
  AI:          'https://img.icons8.com/?size=512&id=KQfGcnxd2gfU&format=png&color=000000',
  Books:       'https://img.icons8.com/?size=512&id=L5K3MFORlcsa&format=png&color=000000',
  Chess:       'https://img.icons8.com/?size=512&id=23835&format=png&color=000000',
}
